import React from 'react'

export default function Header({ title }: { title: string }) {
    return (
        <div className=" flex justify-between items-center my-1">
            <div className=" w-full border-t border-black"></div>
            <p className=" text-sm w-full">{title}</p>
            <div className=" w-full border-t border-black"></div>
        </div>
    )
}
